import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { useChecklistEntregaListaViewModel } from "../../viewModels/checklist_entrega_lista_view_model"
import { GenerateChecklistEntregaColumns } from "./columns"
import { ChecklistEntregaLista as ChecklistEntregaListaDao } from "../../../domain/models/checklist_entrega_lista"
import { CopiaChecklistEntregaModal } from "./components/copia_checklist_entrega_modal"
import { CadastroChecklistEntregaModal } from "./components/cadastro_checklist_entrega_modal"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"

export const ChecklistEntregaLista = () => {
    const viewModel = useChecklistEntregaListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateChecklistEntregaColumns({
            onActionEdit: viewModel.handleChecklistEntregaOpenState,
            onActionDelete: viewModel.handleChecklistEntregaDeleteOpenState,
            onActionCopia: viewModel.handleChecklistEntregaCopiaOpenState,
            onActionItens: viewModel.handleEditItens,
            onActionExportReport: viewModel.handleExportReport,
        });
    }, [
        viewModel.handleChecklistEntregaOpenState,
        viewModel.handleChecklistEntregaDeleteOpenState,
        viewModel.handleChecklistEntregaCopiaOpenState,
        viewModel.handleEditItens,
        viewModel.handleExportReport,
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleChecklistEntregaOpenState(null, true)}>
                                    Novo Checklist
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Checklist de Entrega
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Checklist de Entrega</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>

                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                codigo={viewModel.filters.codigo}
                                descricao={viewModel.filters.descricao}
                                status={viewModel.filters.status}
                                handleCodigoChange={viewModel.handleCodigoChange}
                                handleDescricaoChange={viewModel.handleDescricaoChange}
                                onClearFilters={viewModel.handleClearFilters}
                                handleStatusChange={viewModel.handleStatusChange}
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="Clientes_Lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ChecklistEntregaListaDao) => row.idChecklistEntrega}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.checklistEntregaLista}
                                    rowCount={viewModel.checklistEntregaLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idChecklistEntrega'],
                                    }}
                                    getRowHeight={() => 'auto'}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }
            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleChecklistEntregaDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarChecklistEntrega}
            />

            <CopiaChecklistEntregaModal
                open={viewModel.openCopiaModal}
                saving={viewModel.saving}
                selectedChecklistEntrega={viewModel.selectedChecklistEntrega}
                onClose={() => viewModel.handleChecklistEntregaCopiaOpenState(null, false)}
                onSubmit={viewModel.handleSubmitChecklistEntregaCopia}
            />

            <CadastroChecklistEntregaModal
                open={viewModel.openCadastroModal}
                saving={viewModel.saving}
                loading={viewModel.loading}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                selectedChecklistEntrega={viewModel.selectedChecklistEntrega}
                onClose={() => viewModel.handleChecklistEntregaOpenState(null, false)}
                onSubmit={viewModel.handleSubmitChecklistEntrega}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

            <ReportViewerModal
                reportViewerState={viewModel.reportViewerState}
            />

        </>
    )
}
